import { Action } from '@ngrx/store';
import { ContactPersonRole } from '../models/contact-person-role.model';

export enum ReceivingPersonRoleActionTypes {
  LOAD_ROLES = '[Receiving person role] Load roles',
  LOAD_ROLES_COMPLETE = '[Receiving person role] Load roles completed',
  LOAD_FAIL_ROLES = '[Receiving person role] Load fail roles',
  RESET = '[Receiving person role] Roles reset',
}

export class LoadRolesAction implements Action {
  readonly type = ReceivingPersonRoleActionTypes.LOAD_ROLES;

  constructor() {}
}

export class LoadRolesCompleteAction implements Action {
  readonly type = ReceivingPersonRoleActionTypes.LOAD_ROLES_COMPLETE;

  constructor(public payload: ContactPersonRole[]) {}
}

export class LoadFailRolesAction implements Action {
  readonly type = ReceivingPersonRoleActionTypes.LOAD_FAIL_ROLES;

  constructor() {}
}

export class ResetRolesAction implements Action {
  readonly type = ReceivingPersonRoleActionTypes.RESET;

  constructor() {}
}

export type RolesActions = LoadRolesAction | LoadRolesCompleteAction | LoadFailRolesAction | ResetRolesAction;
